import React from "react";
import QuickTaleToOrganizationDetailsContainer from "../../modules/AddQuickTalesToOrganization/containers/QuickTaleToOrganizationDetailsContainer/QuickTaleToOrganizationDetailsContainer";

const AddQuicktalesToOrgDetails = () => {
  return <QuickTaleToOrganizationDetailsContainer />;
};

export default AddQuicktalesToOrgDetails;
